import React from 'react';
import { FileText } from 'lucide-react'; 
import { Card, CardContent } from './ui'; 

const Documentation: React.FC = () => (
  <section className="w-full py-12 md:py-24 lg:py-32">
    <div className="container px-4 md:px-6 flex flex-col justify-center items-center">
      <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight mb-4">Documentation</h2>
      <p className="text-xl text-muted-foreground mb-8">
        Our comprehensive documentation is coming soon. Stay tuned for detailed guides on our algorithmic trading solutions.
      </p>
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center space-y-2 text-center">
            <FileText className="h-12 w-12 text-primary" />
            <h3 className="text-2xl font-bold">Coming Soon</h3>
            <p className="text-muted-foreground">
              We're working hard to bring you detailed documentation. Check back soon for in-depth guides and API references.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  </section>
);

export default Documentation;